import { AgeWidget } from '../components/form/widgets/AgeWidget'
import { EntityIdWidget } from '../components/form/widgets/EntityIdWidget'
import { SelectDueDateWidget } from '../components/form/widgets/SelectDueDateWidget'
import {
  SkrottlappScanFieldStorfe,
  SkrottlappScanFieldSvin,
  SkrottlappScanFieldSau,
  SkrottlappScanFieldRein
} from '../components/form/fields/SkrottlappScanField'
import { TemperatureWidget } from '../components/form/widgets/TemperatureWidget'
import { VassdragField } from '../components/form/fields/VassdragField'
import { ReinbeitedistriktField } from '../components/form/fields/ReinbeitedistriktField'
import { SchemaWidgets } from './schema-utils'
import {
  HashIcon,
  QrCodeIcon,
  CaretDownIcon,
  ToggleLeftIcon,
  CopyIcon
} from 'prove-common'
import { CalendarIcon, MapTrifoldIcon, WavesIcon } from '@phosphor-icons/react'

export const payloadWidgets: SchemaWidgets = [
  {
    id: 'flockId',
    icon: <HashIcon />,
    propKey: 'entityId',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/flockId'
    },
    uiSchema: {
      'ui:widget': EntityIdWidget
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'entityId',
    icon: <HashIcon />,
    propKey: 'entityId',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/entityId'
    },
    uiSchema: {
      'ui:widget': EntityIdWidget
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'entityUELNId',
    icon: <HashIcon />,
    propKey: 'entityId',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/entityUELNId'
    },
    uiSchema: {
      'ui:widget': EntityIdWidget
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'houseId',
    icon: <HashIcon />,
    propKey: 'houseId',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/houseId'
    },
    uiSchema: {
      'ui:widget': EntityIdWidget
    },
    isRequired: false,
    state: 'unselected'
  },
  {
    id: 'skrottlappScanStorfe',
    icon: <QrCodeIcon />,
    propKey: 'skrottlappScan',
    schema: {
      'x-include-in-requisition': false,
      $ref: '#/definitions/skrottlappScanStorfe'
    },
    uiSchema: {
      'ui:field': SkrottlappScanFieldStorfe
    },
    isRequired: false,
    state: 'unselected'
  },
  {
    id: 'skrottlappScanSvin',
    icon: <QrCodeIcon />,
    propKey: 'skrottlappScan',
    schema: {
      'x-include-in-requisition': false,
      $ref: '#/definitions/skrottlappScanSvin'
    },
    uiSchema: {
      'ui:field': SkrottlappScanFieldSvin
    },
    isRequired: false,
    state: 'unselected'
  },
  {
    id: 'skrottlappScanSau',
    icon: <QrCodeIcon />,
    propKey: 'skrottlappScan',
    schema: {
      'x-include-in-requisition': false,
      $ref: '#/definitions/skrottlappScanSau'
    },
    uiSchema: {
      'ui:field': SkrottlappScanFieldSau
    },
    isRequired: false,
    state: 'unselected'
  },
  {
    id: 'skrottlappScanRein',
    icon: <QrCodeIcon />,
    propKey: 'skrottlappScan',
    schema: {
      'x-include-in-requisition': false,
      $ref: '#/definitions/skrottlappScanRein'
    },
    uiSchema: {
      'ui:field': SkrottlappScanFieldRein
    },
    isRequired: false,
    state: 'unselected'
  },
  {
    id: 'gender',
    icon: <CaretDownIcon />,
    propKey: 'gender',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/gender'
    },
    conditionals: [
      {
        $ref: '#/conditionals/gender'
      }
    ],
    uiSchema: {
      'ui:widget': 'radio'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'pregnant',
    icon: <CaretDownIcon />,
    propKey: 'pregnant',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/pregnant'
    },
    uiSchema: {
      'ui:widget': 'radio'
    },
    isRequired: false,
    state: 'hidden'
  },
  {
    id: 'birthLastFourWeeks',
    icon: <CaretDownIcon />,
    propKey: 'birthLastFourWeeks',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/birthLastFourWeeks'
    },
    uiSchema: {
      'ui:widget': 'radio'
    },
    isRequired: false,
    state: 'hidden'
  },
  {
    id: 'conditionAtSampling',
    icon: <CaretDownIcon />,
    propKey: 'conditionAtSampling',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/conditionAtSampling'
    },
    uiSchema: {
      'ui:widget': 'radio'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'countryOfOrigin',
    icon: <CaretDownIcon />,
    propKey: 'countryOfOrigin',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/countryOfOrigin'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'age',
    icon: <HashIcon />,
    propKey: 'age',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/age'
    },
    uiSchema: {
      'ui:widget': AgeWidget
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'treatmentLastFourWeeks',
    icon: <ToggleLeftIcon />,
    propKey: 'treatmentLastFourWeeks',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/treatmentLastFourWeeks'
    },
    conditionals: [
      {
        $ref: '#/conditionals/treatmentLastFourWeeks'
      }
    ],
    uiSchema: {
      'ui:widget': 'radio'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'treatmentDescription',
    icon: <CaretDownIcon />,
    propKey: 'treatmentDescription',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/treatmentDescription'
    },
    uiSchema: {
      'ui:widget': 'textarea'
    },
    isRequired: false,
    state: 'hidden'
  },
  {
    id: 'organicProduction',
    icon: <ToggleLeftIcon />,
    propKey: 'organicProduction',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/organicProduction'
    },
    uiSchema: {
      'ui:widget': 'radio'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'eftakode',
    icon: <HashIcon />,
    propKey: 'eftakode',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/eftakode'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'kommunenr',
    icon: <HashIcon />,
    propKey: 'kommunenr',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/kommunenr'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'typeSvineBesetning',
    icon: <CaretDownIcon />,
    propKey: 'typeBesetning',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/typeSvinebesetning'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'subSamplesStorfe',
    icon: <CopyIcon />,
    propKey: 'subSamples',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/subSamplesStorfe'
    },
    uiSchema: {
      items: {
        payload: {
          entityId: {
            'ui:widget': EntityIdWidget
          },
          skrottlappScan: {
            'ui:field': SkrottlappScanFieldStorfe
          }
        }
      }
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'subSamplesSvinSlakteri',
    icon: <CopyIcon />,
    propKey: 'subSamples',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/subSamplesSvinSlakteri'
    },
    uiSchema: {
      items: {
        payload: {
          entityId: {
            'ui:widget': EntityIdWidget
          },
          skrottlappScan: {
            'ui:field': SkrottlappScanFieldSvin
          }
        }
      }
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'subSamplesSvinAnlegg',
    icon: <CopyIcon />,
    propKey: 'subSamples',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/subSamplesSvinAnlegg'
    },
    uiSchema: {
      items: {
        payload: {
          entityId: {
            'ui:widget': EntityIdWidget
          },
          skrottlappScan: {
            'ui:field': SkrottlappScanFieldSvin
          }
        }
      }
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'subSamplesNumber',
    icon: <HashIcon />,
    propKey: 'subSamplesNumber',
    schema: {
      'x-include-in-requisition': false,
      $ref: '#/definitions/subSamplesNumber'
    },
    uiSchema: {
      'ui:widget': 'radio'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'produksjonstype',
    icon: <CaretDownIcon />,
    title: 'Produksjonstype og verdikjede',
    propKey: 'produksjonstype',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/produksjonstype'
    },
    conditionals: [
      {
        $ref: '#/conditionals/produksjonstype'
      }
    ],
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'verdikjede',
    icon: <CaretDownIcon />,
    propKey: 'verdikjede',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/verdikjede'
    },
    isRequired: true,
    state: 'hidden'
  },
  {
    id: 'produksjonstypeStorfe',
    title: 'Produksjonstype og verdikjede (storfe)',
    icon: <CaretDownIcon />,
    propKey: 'produksjonstype',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/produksjonstypeStorfe'
    },
    conditionals: [
      {
        $ref: '#/conditionals/produksjonstypeStorfe'
      }
    ],
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'verdikjedeStorfe',
    icon: <CaretDownIcon />,
    propKey: 'verdikjede',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/verdikjedeStorfe'
    },
    isRequired: true,
    state: 'hidden'
  },
  {
    id: 'produksjonstypeSvin',
    title: 'Produksjonstype og verdikjede (svin)',
    icon: <CaretDownIcon />,
    propKey: 'produksjonstype',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/produksjonstypeSvin'
    },
    conditionals: [
      {
        $ref: '#/conditionals/produksjonstypeSvin'
      }
    ],
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'verdikjedeSvin',
    icon: <CaretDownIcon />,
    propKey: 'verdikjede',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/verdikjedeSvin'
    },
    isRequired: true,
    state: 'hidden'
  },
  {
    id: 'produksjonstypeAkva',
    title: 'Produksjonstype og verdikjede (akva)',
    icon: <CaretDownIcon />,
    propKey: 'produksjonstype',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/produksjonstypeAkva'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'helseStatus',
    icon: <CaretDownIcon />,
    propKey: 'helseStatus',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/helseStatus'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'importert',
    icon: <ToggleLeftIcon />,
    propKey: 'importert',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/importert'
    },
    uiSchema: {
      'ui:widget': 'radio'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'hybrid',
    icon: <CaretDownIcon />,
    propKey: 'hybrid',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/hybrid'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'sertifiseringspliktig',
    icon: <ToggleLeftIcon />,
    propKey: 'sertifiseringspliktig',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/sertifiseringspliktig'
    },
    uiSchema: {
      'ui:widget': 'radio'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'godkjenningspliktig',
    icon: <ToggleLeftIcon />,
    propKey: 'godkjenningspliktig',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/godkjenningspliktig'
    },
    uiSchema: {
      'ui:widget': 'radio'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'batchnummer',
    icon: <HashIcon />,
    propKey: 'batchnummer',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/batchnummer'
    },
    isRequired: false,
    state: 'unselected'
  },
  {
    id: 'holdbarhetsdato',
    icon: <CalendarIcon />,
    propKey: 'holdbarhetsdato',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/holdbarhetsdato'
    },
    uiSchema: {
      'ui:widget': SelectDueDateWidget
    },
    isRequired: false,
    state: 'unselected'
  },
  {
    id: 'hasteNoedslakt',
    icon: <ToggleLeftIcon />,
    propKey: 'hasteNoedslakt',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/hasteNoedslakt'
    },
    uiSchema: {
      'ui:widget': 'radio'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'driftsform',
    icon: <CaretDownIcon />,
    propKey: 'driftsform',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/driftsform'
    },
    isRequired: true,
    state: 'hidden'
  },
  {
    id: 'fysioStadium',
    title: 'Fysiologisk stadium (akva)',
    icon: <CaretDownIcon />,
    propKey: 'fysioStadium',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/fysioStadium'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'fysioStadiumStorfe',
    title: 'Fysiologisk stadium (storfe)',
    icon: <CaretDownIcon />,
    propKey: 'fysioStadium',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/fysioStadiumStorfe'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'sisteEktoparasittbehandling',
    icon: <CalendarIcon />,
    propKey: 'sisteEktoparasittbehandling',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/sisteEktoparasittbehandling'
    },
    uiSchema: {
      'ui:widget': SelectDueDateWidget
    },
    isRequired: false,
    state: 'unselected'
  },
  {
    id: 'vanntemperatur',
    icon: <HashIcon />,
    propKey: 'vanntemperatur',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/vanntemperatur'
    },
    uiSchema: {
      'ui:widget': TemperatureWidget
    },
    isRequired: false,
    state: 'unselected'
  },
  {
    id: 'smaskaletProduksjon',
    icon: <ToggleLeftIcon />,
    propKey: 'smaskaletProduksjon',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/smaskaletProduksjon'
    },
    uiSchema: {
      'ui:widget': 'radio'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'honsType',
    icon: <CaretDownIcon />,
    propKey: 'honsType',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/honsType'
    },
    uiSchema: {
      'ui:widget': 'radio'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'purkeEllerRane',
    icon: <CaretDownIcon />,
    propKey: 'purkeEllerRane',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/purkeEllerRane'
    },
    uiSchema: {
      'ui:widget': 'radio'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'melkStorfeProver',
    icon: <CaretDownIcon />,
    propKey: 'melkStorfeProver',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/melkStorfeProver'
    },
    uiSchema: {
      'ui:widget': 'radio'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'forbehandling',
    icon: <CaretDownIcon />,
    propKey: 'forbehandling',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/forbehandling'
    },
    uiSchema: {
      'ui:label': false,
      nivaa2: {
        'ui:placeholder': 'Velg forbehandling',
        'ui:widget': 'SelectWidget'
      },
      nivaa3: {
        'ui:widget': 'SelectWidget'
      }
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'BSEStatus',
    icon: <CaretDownIcon />,
    propKey: 'BSEStatus',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/BSEStatus'
    },
    isRequired: true,
    state: 'unselected'
  },
  {
    id: 'vassdrag',
    icon: <WavesIcon />,
    propKey: 'vassdrag',
    schema: {
      'x-include-in-requisition': true,
      $ref: '#/definitions/vassdrag'
    },
    uiSchema: {
      'ui:field': VassdragField
    },
    isRequired: false,
    state: 'unselected'
  },
  {
    id: 'reinbeitedistrikt',
    icon: <MapTrifoldIcon />,
    propKey: 'reinbeitedistrikt',
    schema: {
      'x-include-in-requisition': false,
      $ref: '#/definitions/reinbeitedistrikt'
    },
    uiSchema: {
      'ui:field': ReinbeitedistriktField,
      'ui:description': ''
    },
    isRequired: true,
    state: 'unselected'
  }
]
